import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Button, Text } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { fetchHealthPlanMappingList } from '../Store/HealthPlanMappingReducer';
import {
  fetchHealthPlanTypeList,
  fetchPayerAddressList,
  fetchSceneriosList,
  fetchUnmappedHealthPlansList,
} from '../Store/GetDropDownsValuesReducer';
import { AppDispatch } from '../Store/StoreInit';
import { useDispatch, useSelector } from 'react-redux';
import { fetchHealthPlanMasterList } from '../Store/HealthPlanMasterReducer';
import NavBar from './NavBar';
import { fetchPayerMasterList } from '../Store/PayerMasterReducer';

function SignInButton() {
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const fetchData = async () => {
      // await dispatch(fetchHealthPlanMappingList());
       await dispatch(fetchPayerMasterList());
      // await dispatch(fetchHealthPlanTypeList());
      // await dispatch(fetchSceneriosList());
      // await dispatch(fetchHealthPlanMasterList());
       await dispatch(fetchPayerAddressList());
    };
    fetchData();
  }, [isAuthenticated]);

  const handleLogin = () => {
    console.log('handleLogin called');
    instance.loginRedirect();
  };

  const handleLogout = () => {
    console.log('handleLogout called');
    instance.logoutRedirect({ postLogoutRedirectUri: '/' });
  };

  // Get user information from the first account in the accounts array
  const user = accounts[0]?.name || '';
  return (
    <>
      {/* {isAuthenticated ? (
        <Text mr=" 100px">
          <strong>User:</strong> {user}
        </Text>
      ) : (
        ''
      )} */}

      <Button
        h="35px"
        w="fit-content"
        fontSize="15px"
        bg="#002677"
        textColor="white"
        mr="50px"
        onClick={isAuthenticated ? handleLogout : handleLogin}
      >
        {isAuthenticated ? 'Sign out' : 'Sign in'}
      </Button>
    </>
  );
}

export default SignInButton;
